import { l } from '@manychat/manyui'

import { AddOnSlug } from 'common/billing/entities/addOns/interfaces'
import { ProductType } from 'common/core/interfaces/products'

import { SubscriptionElementProps } from './components/SubscriptionElement'

export const getSubscriptionElementPropsByType = (
  type: ProductType | AddOnSlug,
): SubscriptionElementProps | null => {
  let props: SubscriptionElementProps | null = null

  switch (type) {
    case ProductType.INBOX:
      props = { label: l.translate('Inbox') }
      break
    case ProductType.AUTOMATION:
      props = { label: l.translate('Marketing Automation'), lozenge: 'pro' }
      break
    case AddOnSlug.AI:
      props = { label: l.translate('Manychat AI'), lozenge: 'ai' }
      break
    default:
      props = null
  }

  return props
}
